<script setup lang="ts">
import { PSuggestionInputField, PTextFormBody } from '@previo/design-system'
import { onMounted, ref, watch } from 'vue'
import type { PropertyId } from '@previo/codebooks'
import { $t } from '@previo/core'
import { useSwitchPropertyStore } from '~/components/switch-property/store'

type Emits = {
  (e: 'selected-property', propertyId: PropertyId): void
  (e: 'dismiss'): void
}

const emits = defineEmits<Emits>()

const store = useSwitchPropertyStore()
const selectedPropertyId = ref<PropertyId | null>(null)

onMounted(() => {
  store.search().then(() => {
    if (store.properties.length === 1) {
      selectedPropertyId.value = store.properties[0].id
    }
  })
})

watch(selectedPropertyId, (value: PropertyId | null) => {
  if (!value) {
    return
  }

  emits('selected-property', value)
})

const search = (search: string | null): void => {
  store.search(search)
}
</script>

<template>
  <p-suggestion-input-field
    v-model="selectedPropertyId"
    :placeholder="$t('Search by the property name or an ID')"
    :items="store.properties"
    item-value="id"
    item-text="name"
    :loading="store.loading"
    autofocus
    open-mobile-dialog-immediately
    cy="choice-property"
    @filter="(val) => search(val)"
    @mobile-dialog-dismiss="emits('dismiss')"
  >
    <template #item="{ item }">
      <p-text-form-body :text="`[${item.id}] ${item.name}`" />
    </template>
  </p-suggestion-input-field>
</template>
